import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* communityKeywordPopListGet(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call( function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    return axios.post(config.apiUri + "member/communityKeywordPopListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "COMMUNITY_KEYWORD_POP_LIST_SET",
        payload: {
          list: res.data.list,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* communityKeywordUserListGet(action) {
  yield put(loadingSet(true));
  let page = (action.payload.page) ? action.payload.page : 1;
  const {res, err} = yield call( function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('keyword', payload.keyword);
    params.append('timestamp', payload.timestamp);
    params.append('page', page);
    return axios.post(config.apiUri + "member/communityKeywordUserListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      if (res.data.list.length > 0) {
        yield put({
          type: "COMMUNITY_KEYWORD_USER_LIST_SET",
          payload: {
            keyword: action.payload.keyword,
            list: res.data.list,
            page: page,
            isListNext: res.data.isListNext,
            timestamp: action.payload.timestamp,
          },
        });
      }
      else {
        yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: 'キーワードに「'+action.payload.keyword + '」を登録している会員は見つかりませんでした。'} });
      }
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* communityKeywordSearchListGet(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call( function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('word', payload.word);
    return axios.post(config.apiUri + "member/communityKeywordSearchListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      if (res.data.list.length > 0) {
        yield put({
          type: "COMMUNITY_KEYWORD_SEARCH_LIST_SET",
          payload: {
            list: res.data.list,
          },
        });
      }
      else {
        yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: '「' + action.payload.word + '」を含むキーワードは見つかりませんでした。'} });
      }
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('COMMUNITY_KEYWORD_POP_LIST_GET', communityKeywordPopListGet),
  takeLatest('COMMUNITY_KEYWORD_USER_LIST_GET', communityKeywordUserListGet),
  takeLatest('COMMUNITY_KEYWORD_SEARCH_LIST_GET', communityKeywordSearchListGet),
];

export default saga;
